export const LaptopWorkerIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <path
        d="M12,8A3.5,3.5,0,1,0,8.5,4.5,3.5,3.5,0,0,0,12,8Z"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#c4f0eb"
      />
      <path
        d="M16.745,13a4.966,4.966,0,0,0-9.49,0"
        fill="#00e6ca"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M18.5,23H5.5L3.811,16.243A1,1,0,0,1,4.781,15H19.219a1,1,0,0,1,.97,1.242Z" fill="#c4f0eb" />
      <path d="M4.781,15a1,1,0,0,0-.97,1.242L5.5,23H7.723l8-8Z" fill="#f8fafc" />
      <path
        d="M18.5,23H5.5L3.811,16.243A1,1,0,0,1,4.781,15H19.219a1,1,0,0,1,.97,1.242Z"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1,23H23" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12,12v1.5" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M13.167,4.5a5.831,5.831,0,0,0,2.286-.467,3.478,3.478,0,0,0-6.459-1.3A5.812,5.812,0,0,0,13.167,4.5Z"
        fill="#00e6ca"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12,20a1.25,1.25,0,1,0-1.25-1.25A1.25,1.25,0,0,0,12,20Z"
        fill="#00e6ca"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
